// Per-tenant + shared session storage.
// PHONE, NAME, NOTIFY_OK are shared across all Coffeein7 cafés (one consumer identity).
// CART, REF are scoped per tenant.

const PHONE_KEY = "c7_phone";
const NAME_KEY = "c7_name";
const NOTIFY_OK_KEY = "c7_notify_ok";

let currentSlug = "_default";
export const setSessionSlug = (slug) => {
    currentSlug = slug || "_default";
};
export const getSessionSlug = () => currentSlug;

const _cartKey = () => `c7_cart_${currentSlug}`;
const _refKey = () => `c7_ref_${currentSlug}`;
const _refUsedKey = () => `c7_ref_used_${currentSlug}`;

// ============ MILK / CUSTOMIZATION ============

export const MILK_OPTIONS = [
    { id: "regular", label: "Regular", upcharge: 0 },
    { id: "almond", label: "Almond", upcharge: 0.7 },
    { id: "oat", label: "Oat", upcharge: 0.7 },
    { id: "soy", label: "Soy", upcharge: 0.7 },
    { id: "skim", label: "Skim", upcharge: 0 },
];

export const defaultCustomizations = () => ({
    milk: "regular",
    sugar: 0,
    extra_hot: false,
    decaf: false,
});

export const milkUpcharge = (milk) => {
    const m = MILK_OPTIONS.find((x) => x.id === milk);
    return m ? m.upcharge : 0;
};

export const customHash = (c) => {
    if (!c) return "-";
    return `${c.milk || "regular"}-${c.sugar || 0}-${c.extra_hot ? "H" : ""}-${c.decaf ? "D" : ""}`;
};

export const customLabel = (c) => {
    if (!c) return "";
    const parts = [];
    if (c.decaf) parts.push("Decaf");
    if (c.extra_hot) parts.push("Extra hot");
    if (c.milk && c.milk !== "regular") {
        const m = MILK_OPTIONS.find((x) => x.id === c.milk);
        parts.push(m ? `${m.label} milk` : `${c.milk} milk`);
    }
    if (c.sugar === 1) parts.push("1 sugar");
    else if (c.sugar > 1) parts.push(`${c.sugar} sugars`);
    return parts.join(" · ");
};

// ============ SHARED IDENTITY ============

export const getPhone = () => localStorage.getItem(PHONE_KEY) || "";
export const setPhone = (p) => localStorage.setItem(PHONE_KEY, p);
export const clearPhone = () => localStorage.removeItem(PHONE_KEY);

export const getName = () => localStorage.getItem(NAME_KEY) || "";
export const setName = (n) => localStorage.setItem(NAME_KEY, n);
export const clearName = () => localStorage.removeItem(NAME_KEY);

export const getNotifyOk = () => localStorage.getItem(NOTIFY_OK_KEY) === "1";
export const setNotifyOk = (v) => {
    if (v) localStorage.setItem(NOTIFY_OK_KEY, "1");
    else localStorage.removeItem(NOTIFY_OK_KEY);
};

// ============ TENANT-SCOPED ============

export const getRef = () => {
    if (localStorage.getItem(_refUsedKey())) return "";
    return localStorage.getItem(_refKey()) || "";
};
export const setRef = (r) => localStorage.setItem(_refKey(), r);
export const consumeRef = () => localStorage.setItem(_refUsedKey(), "1");

export const getCart = () => {
    try {
        return JSON.parse(localStorage.getItem(_cartKey()) || "[]");
    } catch {
        return [];
    }
};
export const setCart = (items) => localStorage.setItem(_cartKey(), JSON.stringify(items));
export const clearCart = () => localStorage.removeItem(_cartKey());

export const cartCount = (items) => items.reduce((s, i) => s + i.qty, 0);
export const cartSubtotal = (items) => items.reduce((s, i) => s + i.qty * i.price, 0);

export const cartKey = (item) =>
    `${item.id}-${item.size || "-"}-${customHash(item.customizations)}`;

export const addToCart = (item) => {
    const items = getCart();
    const k = cartKey(item);
    const idx = items.findIndex((i) => cartKey(i) === k);
    if (idx >= 0) items[idx].qty += item.qty;
    else items.push(item);
    setCart(items);
    return items;
};

export const updateQty = (key, qty) => {
    let items = getCart();
    if (qty <= 0) items = items.filter((i) => cartKey(i) !== key);
    else items = items.map((i) => (cartKey(i) === key ? { ...i, qty } : i));
    setCart(items);
    return items;
};
